import angular from 'angular';

import routing from './tutorial.routes';
import TutorialCtrl from './tutorial.controller';

export default angular.module('app.signin')
	.config(routing)
	.controller('TutorialCtrl', TutorialCtrl)
	.name;



// WEBPACK FOOTER //
// ./project/pages/tutorial/index.js